import { Videostrip } from 'types/studio/studio';
import { Typography, getTypographyDefaultColor } from '@ag1/ui';
import clsx from 'clsx';
import CustomPortableText from '../../PortableText/PortableText';
import styles from './VideostripInfo.module.scss';

type Props = Pick<Videostrip, 'textBlock' | 'theme'>;

const VideostripInfo = (props: Props) => {
  const { textBlock, theme } = props;

  if (!textBlock) {
    return null;
  }

  return (
    <div
      className={clsx(styles.root, !textBlock.subtitle && !textBlock.bodyText && styles.topSpace)}>
      {textBlock.subtitle && (
        <Typography
          variant="subtitle"
          component="div"
          size="1"
          noPadding
          color={getTypographyDefaultColor(theme)}>
          <CustomPortableText value={textBlock.subtitle} />
        </Typography>
      )}
      <Typography
        variant="headlineSans"
        component="div"
        size="2"
        noPadding
        color={getTypographyDefaultColor(theme)}>
        <CustomPortableText value={textBlock.headline} />
      </Typography>
      {textBlock.bodyText && (
        <Typography
          variant="body"
          size="1"
          component="div"
          noPadding
          color={getTypographyDefaultColor(theme)}>
          <CustomPortableText value={textBlock.bodyText} />
        </Typography>
      )}
    </div>
  );
};

export default VideostripInfo;
